<section fxFlex fxLayout="column" fxLayoutGap="10px">
  <iot-platform-ui-detail-popup-section-header
    headerTitle="{{ (totalAssets() > 1 ? 'IOT_DICTIONARY.assets' : 'IOT_DICTIONARY.asset') | translate }} ({{ totalAssets() }})"
  ></iot-platform-ui-detail-popup-section-header>
  @if (loaded()) {
    <iot-platform-ui-detail-assets-card
      (selectItem)="selectAsset.emit($event)"
      [assets]="assets()"
      [ngClass]="{ invisible: !loaded(), visible: loaded() }"
      [total]="totalAssets()"
    ></iot-platform-ui-detail-assets-card>
  } @else {
    <iot-platform-ui-card-loader [backgroundClass]="'mv-detail-card h-60'"></iot-platform-ui-card-loader>
  }
</section>
